import React from "react";
import "./orderTableProduct.scss";
import { ReactComponent as Wero } from "../../icons/wero.svg";
import { ReactComponent as WeroUSA } from "../../icons/weroUSA.svg";
import { ReactComponent as WeroChina } from "../../icons/weroChina.svg";

const OrderTableProduct = ({ order }) => {
  return (
    // <div className="order-table-product">
    <>
      {order?.branch?.name === "USA" ? (
        <WeroUSA className="product" />
      ) : order?.branch?.name === "China" ? (
        <WeroChina className="product" />
      ) : (
        <Wero className="product" />
      )}
      </>
    // </div>
  );
};

export default OrderTableProduct;
